import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_3 = {
  class: "searchBox"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" - ");

const _hoisted_6 = {
  key: 0,
  id: "lyric"
};
const _hoisted_7 = {
  key: 1,
  class: "tip_center"
};
const _hoisted_8 = {
  class: "markBox"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M710.549333 384.810667a12409.045333 12409.045333 0 0 0 47.466667-0.32l8.746667-0.085334c83.989333-0.618667 141.44 67.584 126.72 150.229334L847.296 794.026667c-10.026667 56.448-63.914667 101.546667-121.130667 101.589333L298.624 896a42.730667 42.730667 0 0 1-42.666667-42.410667l-0.810666-383.978666a42.666667 42.666667 0 0 1 42.026666-42.666667l3.157334-0.064c5.226667-0.042667 11.797333-0.042667 19.626666 0 91.946667 0.768 170.88-86.698667 170.709334-170.944-0.149333-86.741333 39.786667-126.762667 106.453333-127.573333 62.250667-0.746667 106.602667 59.605333 107.349333 149.12 0.213333 26.602667-6.293333 73.237333-14.506666 107.434666 6.186667 0 13.077333-0.042667 20.586666-0.085333z m-497.706666 63.232L213.333333 874.624A21.312 21.312 0 0 1 191.786667 896H149.525333A21.333333 21.333333 0 0 1 128 874.624l0.042667-426.581333A21.269333 21.269333 0 0 1 149.44 426.666667h41.984c11.669333 0 21.418667 9.578667 21.418667 21.376z",
  fill: "#3D3D3D"
})], -1);

const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  style: {
    "transform": "rotate(180deg)"
  },
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M710.549333 384.810667a12409.045333 12409.045333 0 0 0 47.466667-0.32l8.746667-0.085334c83.989333-0.618667 141.44 67.584 126.72 150.229334L847.296 794.026667c-10.026667 56.448-63.914667 101.546667-121.130667 101.589333L298.624 896a42.730667 42.730667 0 0 1-42.666667-42.410667l-0.810666-383.978666a42.666667 42.666667 0 0 1 42.026666-42.666667l3.157334-0.064c5.226667-0.042667 11.797333-0.042667 19.626666 0 91.946667 0.768 170.88-86.698667 170.709334-170.944-0.149333-86.741333 39.786667-126.762667 106.453333-127.573333 62.250667-0.746667 106.602667 59.605333 107.349333 149.12 0.213333 26.602667-6.293333 73.237333-14.506666 107.434666 6.186667 0 13.077333-0.042667 20.586666-0.085333z m-497.706666 63.232L213.333333 874.624A21.312 21.312 0 0 1 191.786667 896H149.525333A21.333333 21.333333 0 0 1 128 874.624l0.042667-426.581333A21.269333 21.269333 0 0 1 149.44 426.666667h41.984c11.669333 0 21.418667 9.578667 21.418667 21.376z",
  fill: "#3D3D3D"
}, null, -1);

const _hoisted_13 = [_hoisted_12];

const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M64 480h352V128H64v352z m64-288h224v224H128V192zM64 928h352V576H64v352z m64-288h224v224H128v-224zM526.848 224H928a32 32 0 1 0 0-64H526.848a32 32 0 0 0 0 64zM928 608H526.848a32 32 0 1 0 0 64H928a32 32 0 1 0 0-64zM928 384H526.848a32 32 0 0 0 0 64H928a32 32 0 1 0 0-64zM928 832H526.848a32 32 0 1 0 0 64H928a32 32 0 1 0 0-64z"
})], -1);

const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  key: 0,
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};

const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M512.271856 139.636751 512.271856 0 326.090231 186.181624l186.181624 186.181624L512.271856 232.727563c153.599467 0 279.272437 125.67297 279.272437 279.272437 0 46.544873-13.963782 93.090812-32.582157 130.327563l69.817843 69.817843c32.582157-60.508655 55.854061-125.67297 55.854061-200.145406C884.635104 307.2 717.071856 139.636751 512.271856 139.636751zM512.271856 791.272437c-153.599467 0-279.272437-125.67297-279.272437-279.272437 0-46.545939 13.963782-93.090812 32.582157-130.327563l-69.817843-69.817843c-32.582157 60.508655-55.854061 125.67297-55.854061 200.145406 0 204.8 167.563249 372.363249 372.363249 372.363249l0 139.636751 186.181624-186.181624-186.181624-186.181624L512.272922 791.272437z",
  fill: "#272636"
}, null, -1);

const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  key: 1,
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};

const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  d: "M439.977387 51.413333a42.666667 42.666667 0 0 0 1.962666 60.288l17.365334 16.298667H384.425387a384 384 0 0 0-103.424 753.92l-0.981334-0.554667a42.666667 42.666667 0 0 0 18.346667 1.365334l0.725333 0.085333v-0.170667a42.666667 42.666667 0 0 0 0-84.266666v-0.085334A298.666667 298.666667 0 0 1 384.425387 213.333333h82.346666l-26.026666 24.832a42.666667 42.666667 0 0 0 59.008 61.696l99.925333-95.573333a42.666667 42.666667 0 0 0-0.298667-61.952L500.265387 49.493333a42.666667 42.666667 0 0 0-60.288 1.962667zM558.71872 896l23.978667 22.912a42.666667 42.666667 0 1 1-58.965334 61.696l-99.925333-95.573333a42.666667 42.666667 0 0 1 0.298667-61.952l99.114666-92.885334a42.666667 42.666667 0 0 1 58.325334 62.293334l-19.413334 18.176H640.425387a298.666667 298.666667 0 0 0 85.76-584.832 42.666667 42.666667 0 1 1 13.525333-84.266667l2.005333-0.085333A384 384 0 0 1 640.425387 896h-81.706667z",
  fill: "#303133"
}, null, -1);

const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  d: "M612.692053 670.72h-200.533333v-61.44h67.413333v-180.48H421.11872v-46.933333c34.133333-6.4 56.32-14.933333 78.506667-28.586667h55.893333v256h57.173333v61.44z",
  fill: "#303133"
}, null, -1);

const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = {
  key: 2,
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  d: "M768.863 325.733c-48.775 0-170.409 121.182-259.229 207.077-134.661 130.244-261.862 256.802-363.67 256.802h-62.62C57.75 789.612 37 768.828 37 743.223c0-25.604 20.749-46.387 46.342-46.387h62.622c64.335 0 194.592-129.518 299.256-230.745 127.382-123.198 237.392-233.135 323.643-233.135h59.769l-63.418-61.55c-18.113-18.088-18.142-45.665-0.062-63.788 18.08-18.128 47.422-18.164 65.535-0.07l142.708 142.495A46.306 46.306 0 0 1 987 282.83c0 12.308-4.893 24.06-13.604 32.759l-142.71 142.4c-9.043 9.032-20.89 13.328-32.735 13.328-11.875 0-23.749-4.977-32.799-14.05-18.08-18.121-18.05-48.358 0.062-66.445l63.417-65.09h-59.768z m61.824 238.627c-18.113-18.095-47.456-18.066-65.535 0.062-18.08 18.121-18.05 49.237 0.062 67.323l63.417 65.09h-59.768c-38.06 0-101.643-56.357-164.685-115.353-18.69-17.493-48.021-17.394-65.495 1.306-17.486 18.7-16.507 49.382 2.183 66.87 96.042 89.898 160.826 139.952 227.997 139.952h59.769l-63.418 61.549c-18.113 18.087-18.142 46.552-0.062 64.674 9.051 9.072 20.924 13.167 32.799 13.167 11.845 0 23.692-4.74 32.736-13.773l142.708-142.619c8.71-8.7 13.604-20.56 13.604-32.87a46.44 46.44 0 0 0-13.604-32.842L830.687 564.36zM83.342 325.733h62.622c48.84 0 121.646 62.22 179.612 114.893 8.88 8.065 20.026 12.923 31.147 12.923 12.604 0 25.172-4.677 34.315-14.75 17.208-18.954 15.8-49.839-3.146-67.055-90.646-82.365-166.477-138.787-241.928-138.787H83.342C57.749 232.957 37 253.743 37 279.346s20.75 46.387 46.342 46.387z",
  fill: "#000000"
}, null, -1);

const _hoisted_25 = [_hoisted_24];
const _hoisted_26 = {
  class: "imgBox"
};
const _hoisted_27 = {
  class: "songRound"
};
const _hoisted_28 = ["src"];

const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "imgMask"
}, null, -1);

const _hoisted_30 = {
  key: 0,
  opacity: "50%",
  class: "icon",
  width: "50px",
  height: "50px",
  viewBox: "0 0 1048 1024",
  xmlns: "http://www.w3.org/2000/svg"
};

const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", {
  d: "M524.272128 0.018022C241.513165 0.018022 12.288102 229.245952 12.288102 512.005018c0 112.734003 36.43904 216.957952 98.17897 301.537997l38.667981-40.258048C97.458176 699.230003 67.143168 609.158963 67.143168 512.005018 67.143168 259.540992 271.807078 54.872986 524.272128 54.872986c252.45696 0 457.120973 204.668006 457.120973 457.132032 0 252.460954-204.664013 457.118003-457.120973 457.118003-96.240026 0-185.530982-29.744026-259.189043-80.53504l-34.539008 42.797978c83.150029 58.344038 184.437965 92.596019 293.728973 92.596019 282.758963 0 511.984026-229.220966 511.984026-511.976038C1036.256154 229.245952 807.031091 0.018022 524.272128 0.018022zM615.693107 256.011981l0 511.987 54.855 0L670.548107 256.012 615.693128 256.012zM377.996083 256.011981l0 511.987 54.855 0L432.851083 256.012 377.996128 256.012z"
}, null, -1);

const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 1,
  width: "50px",
  height: "50.00px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_34 = /*#__PURE__*/_createElementVNode("path", {
  d: "M885.2 352.3c-20.4-48.2-49.6-91.5-86.8-128.7-37.2-37.2-80.5-66.4-128.7-86.8-50-21.1-103-31.8-157.7-31.8s-107.7 10.7-157.7 31.8c-48.2 20.4-91.5 49.6-128.7 86.8-37.2 37.2-66.4 80.5-86.8 128.7-21.1 50-31.8 103-31.8 157.7 0 78.9 22.7 155.5 65.7 221.3 7.9 12.1 24.1 15.5 36.2 7.6 12.1-7.9 15.5-24.1 7.6-36.2-37.4-57.3-57.2-123.9-57.2-192.6 0-194.4 158.2-352.6 352.6-352.6S864.6 315.6 864.6 510 706.4 862.6 512 862.6c-67.8 0-133.7-19.3-190.4-55.8-12.2-7.8-28.4-4.3-36.2 7.9-7.8 12.2-4.3 28.4 7.9 36.2C358.5 892.8 434.1 915 512 915c54.7 0 107.7-10.7 157.7-31.8 48.2-20.4 91.5-49.6 128.7-86.8 37.2-37.2 66.4-80.5 86.8-128.7 21.1-49.9 31.8-103 31.8-157.7s-10.7-107.7-31.8-157.7z",
  fill: "#B3B3B3"
}, null, -1);

const _hoisted_35 = /*#__PURE__*/_createElementVNode("path", {
  d: "M453.1 665.1l222.7-128.6c1.3-0.8 2.6-1.6 3.7-2.6 2.9-2.2 5.5-5 7.4-8.3 7.6-13.2 3.1-30.2-10.1-37.9L452.5 358.3c-11.6-6.7-26.1-4-34.7 5.7-4.6 5-7.4 11.6-7.4 18.8v257.5c0 9.3 4.6 17.5 11.7 22.6 8.7 6.7 21 8 31 2.2zM465.9 430l141.7 81.8-141.7 81.8V430z",
  fill: "#B3B3B3"
}, null, -1);

const _hoisted_36 = [_hoisted_34, _hoisted_35];
const _hoisted_37 = {
  class: "control"
};

const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M803.584 134.592c-18.176-10.048-39.936-10.112-58.112 0L192 443.008l0-282.88c0-17.664-14.336-32-32-32S128 142.464 128 160.128l0 344.896C127.744 507.2 127.104 509.248 127.104 511.488S127.744 515.84 128 518.016l0 346.112c0 17.664 14.336 32 32 32s32-14.336 32-32L192 579.968l553.408 308.352C754.56 893.44 764.48 896 774.528 896s19.968-2.56 29.056-7.616c18.176-10.112 28.992-28.224 28.992-48.576L832.576 183.104C832.576 162.88 821.76 144.768 803.584 134.592zM768.192 829.248 198.016 511.488 771.328 192 768.192 829.248z"
}, null, -1);

const _hoisted_39 = [_hoisted_38];

const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M192.512 899.072c-5.632 0-11.264-1.536-15.872-4.096-9.728-5.632-15.872-16.384-15.872-27.648V159.232c0-11.264 6.144-22.016 15.872-27.648 9.728-5.632 22.016-5.632 31.744 0l612.864 353.792c9.728 5.632 15.872 16.384 15.872 27.648s-6.144 22.016-15.872 27.648L208.896 894.464c-5.12 3.072-10.752 4.608-16.384 4.608z m32.256-684.544v596.992l516.608-298.496L224.768 214.528z"
}, null, -1);

const _hoisted_41 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M821.76 899.072c-22.016 0-39.936-17.92-39.936-39.936V166.912c0-22.016 17.92-39.936 39.936-39.936s39.936 17.92 39.936 39.936v691.712c0 22.528-17.92 40.448-39.936 40.448z"
}, null, -1);

const _hoisted_42 = [_hoisted_40, _hoisted_41];
const _hoisted_43 = {
  id: "bottom_layer",
  class: "s-bottom-layer s-isindex-wrap",
  style: {
    "visibility": "visible",
    "width": "100%"
  }
};
const _hoisted_44 = {
  class: "s-bottom-layer-content"
};
const _hoisted_45 = {
  class: "lh"
};

const _hoisted_46 = /*#__PURE__*/_createTextVNode("关于hej6666");

const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", {
  class: "lh"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "text-color",
  href: "https://beian.miit.gov.cn/",
  target: "_blank",
  "one-link-mark": "yes"
}, "粤ICP备2022088590号-1")], -1);

const _hoisted_48 = ["onClick"];
const _hoisted_49 = {
  class: "demo-pagination-block"
};
const _hoisted_50 = ["onClick"];

const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M607.897867 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L575.903242 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 351.94087C639.892491 753.593818 625.61532 768.043004 607.897867 768.043004z"
}, null, -1);

const _hoisted_52 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M415.930119 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L383.935495 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625 17.717453 0 31.994625 14.277171 31.994625 31.994625l0 351.94087C447.924744 753.593818 433.647573 768.043004 415.930119 768.043004z"
}, null, -1);

const _hoisted_53 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M928.016126 223.962372l-159.973123 0L768.043004 159.973123c0-52.980346-42.659499-95.983874-95.295817-95.983874L351.94087 63.989249c-52.980346 0-95.983874 43.003528-95.983874 95.983874l0 63.989249-159.973123 0c-17.717453 0-31.994625 14.277171-31.994625 31.994625s14.277171 31.994625 31.994625 31.994625l832.032253 0c17.717453 0 31.994625-14.277171 31.994625-31.994625S945.73358 223.962372 928.016126 223.962372zM319.946246 159.973123c0-17.545439 14.449185-31.994625 31.994625-31.994625l320.806316 0c17.545439 0 31.306568 14.105157 31.306568 31.994625l0 63.989249L319.946246 223.962372 319.946246 159.973123 319.946246 159.973123z"
}, null, -1);

const _hoisted_54 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000000",
  d: "M736.048379 960.010751 288.123635 960.010751c-52.980346 0-95.983874-43.003528-95.983874-95.983874L192.139761 383.591466c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 480.435411c0 17.717453 14.449185 31.994625 31.994625 31.994625l448.096758 0c17.717453 0 31.994625-14.277171 31.994625-31.994625L768.215018 384.795565c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 479.231312C832.032253 916.835209 789.028725 960.010751 736.048379 960.010751z"
}, null, -1);

const _hoisted_55 = [_hoisted_51, _hoisted_52, _hoisted_53, _hoisted_54];
const _hoisted_56 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_router_link = _resolveComponent("router-link");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_el_dialog = _resolveComponent("el-dialog");

  const _component_el_drawer = _resolveComponent("el-drawer");

  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("audio", {
    id: "audio",
    controls: "",
    name: "media",
    ref: "audio",
    src: _ctx.src,
    onEnded: _cache[0] || (_cache[0] = $event => $setup.end_music())
  }, " 您的浏览器不支持 audio 标签。 ", 40, _hoisted_1), [[_vShow, false]]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
    class: "searchInput",
    modelValue: $setup.searchValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.searchValue = $event),
    placeholder: "搜索歌手或歌名"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.searchFn
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("h3", null, [_createElementVNode("span", null, _toDisplayString(_ctx.title), 1), _hoisted_5, _createElementVNode("span", null, _toDisplayString(_ctx.singer), 1)]), _createElementVNode("div", {
    class: "lyric",
    onMouseup: _cache[2] || (_cache[2] = (...args) => $setup.huaDong && $setup.huaDong(...args)),
    onMousedown: _cache[3] || (_cache[3] = (...args) => $setup.anXia && $setup.anXia(...args))
  }, [_ctx.lyric.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lyric, (lineLyric, key) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass(["lyricLine", $setup.lyricIdx == key ? 'nowLyric' : '']),
      key: key
    }, _toDisplayString(lineLyric.lineLyric), 3);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无歌词"))], 32), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.music_zan && $setup.music_zan(...args))
  }, _hoisted_10), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.music_cai && $setup.music_cai(...args))
  }, [(_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))])]), _createElementVNode("div", {
    class: "songList",
    onClick: _cache[6] || (_cache[6] = $event => $setup.table = true)
  }, _hoisted_15), _createElementVNode("div", {
    class: "playModel",
    onClick: _cache[7] || (_cache[7] = $event => $setup.nextModel())
  }, [_ctx.mode_idx == 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18)) : _ctx.mode_idx == 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22)) : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    class: "songImg imgRotate",
    style: _normalizeStyle({
      'animation-play-state': _ctx.status ? 'running' : 'paused'
    }),
    src: _ctx.img,
    alt: "pic",
    width: "200",
    height: "200"
  }, null, 12, _hoisted_28), _hoisted_29]), _createElementVNode("div", {
    class: "play_icon",
    onClick: _cache[8] || (_cache[8] = $event => $setup.setMusicState(!_ctx.status))
  }, [_ctx.status ? (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32)) : (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_36))]), _createElementVNode("div", _hoisted_37, [(_openBlock(), _createElementBlock("svg", {
    onClick: _cache[9] || (_cache[9] = (...args) => $setup.playLast && $setup.playLast(...args)),
    class: "playLast",
    width: "30px",
    height: "30px",
    viewBox: "0 0 1024 1024"
  }, _hoisted_39)), (_openBlock(), _createElementBlock("svg", {
    onClick: _cache[10] || (_cache[10] = (...args) => $setup.playNext && $setup.playNext(...args)),
    class: "playNext",
    width: "30px",
    height: "30px",
    viewBox: "0 0 1024 1024"
  }, _hoisted_42))])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("p", _hoisted_45, [_createVNode(_component_router_link, {
    to: "/about"
  }, {
    default: _withCtx(() => [_hoisted_46]),
    _: 1
  })]), _hoisted_47])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogTableVisible,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.dialogTableVisible = $event),
    title: '搜索词：' + $setup.searchValue
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "当前页：" + _toDisplayString($setup.serCurPage), 1), _createElementVNode("div", null, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.search_List.list, (music, key) => {
      return _openBlock(), _createElementBlock("li", {
        key: music.id
      }, [_createElementVNode("span", {
        onClick: $event => $setup.addMusicList(key)
      }, _toDisplayString(music.music_singer) + "---" + _toDisplayString(music.music_name), 9, _hoisted_48)]);
    }), 128))])]), _createElementVNode("div", _hoisted_49, [_createVNode(_component_el_pagination, {
      "current-page": $setup.serCurPage,
      "onUpdate:current-page": _cache[11] || (_cache[11] = $event => $setup.serCurPage = $event),
      "page-size": $setup.pageSize,
      "onUpdate:page-size": _cache[12] || (_cache[12] = $event => $setup.pageSize = $event),
      disabled: $setup.serDisabled,
      layout: "prev, next",
      total: $setup.serCount,
      onCurrentChange: $setup.handleCurrentChange
    }, null, 8, ["current-page", "page-size", "disabled", "total", "onCurrentChange"])]), _createElementVNode("span", null, "总页码：" + _toDisplayString(Math.ceil($setup.serCount / 10)), 1)]),
    _: 1
  }, 8, ["modelValue", "title"]), _createVNode(_component_el_drawer, {
    modelValue: $setup.table,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.table = $event),
    title: "歌曲列表",
    direction: "rtl",
    size: "80%"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.music_list, (music, key) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(["music_list", key == _ctx.index ? 'red' : '']),
        key: music.id
      }, [(_openBlock(), _createElementBlock("svg", {
        onClick: $event => $setup.delMusic(key),
        style: {
          "vertical-align": "middle",
          "margin": "0 10px 5px 0"
        },
        class: "icon",
        width: "20px",
        height: "20px",
        viewBox: "0 0 1024 1024"
      }, _hoisted_55, 8, _hoisted_50)), _createElementVNode("span", {
        onClick: $event => $setup.clickPlayMusic(key)
      }, _toDisplayString(music.music_singer) + "---" + _toDisplayString(music.music_name), 9, _hoisted_56)], 2);
    }), 128))])])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}